import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enSwap from "./locales/en/swap.json";
import deSwap from "./locales/de/swap.json";

const STORAGE_KEY = "language";
const SUPPORTED_LANGUAGES = ["en", "de"] as const;
type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const detectLanguage = (): SupportedLanguage => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED_LANGUAGES.includes(stored as SupportedLanguage)) {
    return stored as SupportedLanguage;
  }

  const browserLang = navigator.language?.split("-")[0] || "en";
  if (SUPPORTED_LANGUAGES.includes(browserLang as SupportedLanguage)) {
    return browserLang as SupportedLanguage;
  }

  return "en";
};

export const setLanguage = (lang: SupportedLanguage) => {
  localStorage.setItem(STORAGE_KEY, lang);
  i18n.changeLanguage(lang);
};

export const getLanguage = (): SupportedLanguage => {
  return i18n.language as SupportedLanguage;
};

i18n.use(initReactI18next).init({
  resources: {
    en: { swap: enSwap },
    de: { swap: deSwap },
  },
  lng: detectLanguage(),
  fallbackLng: "en",
  defaultNS: "swap",
  ns: ["swap"],
  interpolation: {
    escapeValue: false,
  },
});

export { i18n, SUPPORTED_LANGUAGES, type SupportedLanguage };
